import React, { useCallback, useEffect, useRef } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import { Iconfont } from "../../../../../components/icon/iconfont";
import CountDown from "../../../../../components/count-down";
import { FormattedMessage } from "react-intl";
import { useMemo } from "react";
import { FullSwiper } from "../../../../moduleable/components/swiper";
import withSouce from '../../../../../hocs/source-scoll'
import deeplink from "../../../../../../utils/deeplink";
import { getSensorsUrl } from "../../../../../utils/sensor";
import { useDispatch } from "react-redux";
import { setOPLoading } from "../../../../../../store/actions/ui";
import { action_fetch_product_vo } from "../../../../../../store/actions/pages/product";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";

const FlashSaleCountDown = props =>{
    const { promotion, serverTime, onCallBackHandle } = props;

    const showCountDown = useMemo(() =>{
        let { startTime, endTime } = promotion;
        // 兼容直接开始的活动没有开始时间期限的活动
        if((!startTime && (endTime > serverTime)) || ((startTime < serverTime) && (endTime > serverTime))){
            return true;
        }else{
            return false;
        }
    },[promotion?.id]);

    

    return <React.Fragment>
        <Iconfont className={classes.Icon}>&#xe624;</Iconfont>
        <span className={classes.Font}>{promotion?.subTitle}</span>
        <span className={classes.Font}><FormattedMessage id="ends_in" defaultMessage="Ends in" /></span>
        {
            showCountDown && <CountDown 
                offset={promotion?.endTime - serverTime} 
                numberClass={`${classes.CountDownFont}`} 
                labelClass={`${classes.CountDownFont}`} 
                dotClass={`${classes.CountDownFont}`} 
                callback={()=>onCallBackHandle(promotion)} 
                showLabel 
                showDay 
                showHour 
            />
        }
    </React.Fragment>
}

const PromotionRollSource = withSouce(props =>{
    const { innerRef, sensors, promotion, productId } = props;


    const handleClick = () =>{
        if(promotion?.deepLink){
            let url = deeplink(promotion?.deepLink, "msite");
            let href;

            if(url.indexOf("?") != -1){
                if(url.split("?")[1]){
                    href = url +'&productId=' + productId + '&activityId=' + promotion?.id
                } else {
                    href = url +'productId=' + productId + '&activityId=' + promotion?.id
                }
            } else {
                href= url +'?productId=' + productId + '&activityId=' + promotion?.id
            }
    
            window.location.href = getSensorsUrl(href, {
                resourcepage_title: 'product',
                resource_position: sensors?.position,
                resource_type: '2',
                resource_content: sensors?.content
            })
        }
    }

    return <div className={`${classes.PromotionItem} ${props?.className?props.className:""}`} style={props?.style}>
        <span 
            className={classes.LinkItem}
            ref={innerRef}
            data-position={`${sensors?.position}`}
            data-type={'2'}
            data-content={sensors?.content}
            data-title={"product"}
            onClick={handleClick}
        >
            {props.children}
        </span>
    </div>
})

const PromotionRoll = props =>{
    const { promotions, productId, serverTime, isImage } = props;
    const countRef = useRef(true);
    const dispatch = useDispatch();

    const disposePromotion = (promotion) =>{
        if(promotion?.startTime && promotion.endTime){
            return 'rgba(255,219,120,.8)';
        }else{
            return 'rgba(254,236,232,.8)'
        }
    }

    const onCallBackHandle = useCallback(async (p) =>{
        if(p?.activeType == "2" && p?.promotionType == "8"){
            // 因为swiper loop会重复组件 导致事件重发两次
            if(countRef.current){
                countRef.current = false;
                dispatch(setOPLoading(true));
                await dispatch(action_fetch_product_vo(productId, null));
                dispatch(setOPLoading(false));
            }
            
        }
    }, [productId]);

    const getDefaultColor = promotion => {
        if(promotion?.backgroundColor?.toLowerCase() === '#e64545')
            return {color: '#fff'}
        return {}
    }

    return <FullSwiper
        items={promotions}
        options={{
            loop: promotions?.length > 1,
            autoplay: promotions?.length > 1 ? {
                disableOnInteraction:false,
                delay: 5000
            } : false
        }}
        render={(promotion, index) =>{
            const defaultStyle = getDefaultColor(promotion)

            return <PromotionRollSource 
                key={index+promotion?.id} 
                promotion={promotion} 
                sensors={{position: index+1, content: promotion?.description}} 
                productId={productId} 
                className={isImage?classes.BgImagePromotion:""}
                style={{ ...defaultStyle ,background:`${isImage ? "transparent": promotion?.backgroundColor || disposePromotion(promotion)}`}}
            >
                {
                    promotion?.endTime ? <React.Fragment>
                        <FlashSaleCountDown promotion={promotion} serverTime={serverTime} productId={productId} onCallBackHandle={onCallBackHandle} />
                    </React.Fragment> : <React.Fragment>
                        <span className={classes.Font}>{promotion?.title}</span>
                        <span className={classes.Font}>{promotion?.description}</span>
                    </React.Fragment>
                }
            </PromotionRollSource>
        }}
    >
    </FullSwiper>
}

export const UtmLimitDiscount = props =>{
    useStyles(classes);
    const { promotion, offset } = props;

    return <div className={classes.UtmLimitDiscount}>
        <span className={classes.Font}>{promotion?.title}</span>

        <div>
            <span className={classes.Font}><FormattedMessage id="ends_in" defaultMessage="Ends in" /></span>&nbsp;
            <CountDown 
                offset={offset} 
                numberClass={`${classes.Font}`} 
                labelClass={`${classes.Font}`} 
                dotClass={`${classes.Font}`} 
                showLabel 
                showDay 
                showHour 
            />
        </div>
    </div>
}

export const ProductPromotionBgImage = props =>{
    useStyles(classes);
    const { promotionalSign, promotionImage } = props;

    return <div className={classes.ProductPromotionBgImage} style={{ backgroundImage: `url(${IMAGE_GEEKO_LTD}${promotionImage})` }}>
        <div className={classes.BgImage}>
            <div className={classes.PromotionalSign}>
                {
                    (promotionalSign?.endTime - promotionalSign?.serverTime > 1000) ? <span className={`${classes.TitleText}`}>
                        <span className={classes.SText}>
                            <FormattedMessage id="flash_sale" defaultMessage="Flash Sale" /> <FormattedMessage id="ends_in" defaultMessage="Ends in" />&nbsp;
                        </span>

                        <CountDown
                            numberClass={classes.SText}
                            labelClass={classes.SText}
                            dotClass={classes.SText}
                            offset={promotionalSign.endTime - promotionalSign.serverTime}
                            showHour
                        />
                    </span> : <span className={`${classes.TitleText} ${classes.SText}`}>{promotionalSign?.title}</span>
                }
            </div>
        </div>
    </div>
}


const ProductPromotionContain = props => {
    useStyles(classes);
    const { promotions, productId, serverTime } = props;
    // console.log('props', props)

    // const flashSale = useMemo(() =>{
    //     return promotions?.find(item=>item.endTime && item.startTime);
    // },[promotions]);
    
    return <div className={classes.ProductPromotionContain}>
        <PromotionRoll promotions={promotions} productId={productId} serverTime={serverTime} />
    </div>
}

export default ProductPromotionContain;